import { render } from "./SectionInvoice.vue?vue&type=template&id=23110cf6"
import script from "./SectionInvoice.vue?vue&type=script&lang=js"
export * from "./SectionInvoice.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__